<div class="spinner size-{{ size }}">
  <div class="size-{{ size }}">
    <div class="size-{{ size }}"></div>
    <div class="size-{{ size }}"></div>
    <div class="size-{{ size }}"></div>
    <div class="size-{{ size }}"></div>
  </div>
</div>
